module.exports = {
  "className": "PhoenixVoucher",
  "limit": 10,
  "showExport": false,
  "showView": true,
  "showCreate": false,
  "showUpdate": false,
  "showDelete": false,
  "columns": [
    {
      "columnName": "objectId",
  		"type": "string"
    },
    {
      "columnName": "category",
      "type": "string",
      "style": {
        "whiteSpace": "normal",
        "minWidth": "300px"
      }
    },
    {
      "columnName": "title",
      "type": "string",
      "style": {
        "whiteSpace": "normal",
        "minWidth": "300px"
      }
    },
    // {
    //   "columnName": "totalJoined",
    //   "columnLabel": "Enrolled",
    //   "type": "number",
    //   "style": {
    //     "textAlign": "center"
    //   },
    //   "headerStyle": {
    //     "minWidth": "130px"
    //   }
    // },
    {
      "columnName": "totalRedeemed",
      "columnLabel": "Redeemed",
      "type": "number",
      "style": {
        "textAlign": "center"
      },
      "headerStyle": {
        "minWidth": "130px"
      }
    },
    {
      "columnName": "createdAt",
  		"type": "Date"
    },
    {
      "columnName": "updatedAt",
  		"type": "Date"
    }
  ]
}



// WEBPACK FOOTER //
// ./components/PhoenixVoucher/PhoenixVoucherSchema.js